import { ParamJsonImporter } from "../Param";
export class ParamMultipleJsonImporter extends ParamJsonImporter {
  add_main(data) {
  }
}
